<template lang="pug">
div.default-input-container
  v-text-field(
    :value="value"
    class="default-amount-input"
    suffix="AZN"
    :label="$t(amountInputLabel)"
    :hide-details="isDetailsHidden"
    outlined
    :disabled="isDisabled"
    :rules="rules.amount"
    @keydown="handleKeyDown"
    @input="amountInputHandler($event)"
    )
  span(v-if="!commissionValue || commissionValue <= 0").amount-input-hint.d-flex.align-center
    v-icon(size=16).mr-2 $info-warning
    span.amount-input-hint-text {{ this.inputMinValue && `Min. ${this.inputMinValue} AZN` }}  {{ this.inputMaxValue && `Max. ${this.inputMaxValue} AZN` }}
  span(v-else).amount-input-hint.d-flex.align-center
    v-icon(size=16).mr-2 $percent-warning
    span.amount-input-hint-text.amount-input-hint-warning {{ $t('misc.transfers.commission.warning', {commission: this.commissionValue}) }}
</template>

<script>
import { ValidationRequired } from '@/rules/required';
import { ValidationPattern } from '@/rules/pattern';
import { ValidationNumber } from '@/rules/number';
import { ValidationMin } from '@/rules/min';
import { ValidationMax } from '@/rules/max';
import { ValidationAmount } from '@/rules/amount';
import { ValidationMaxlength } from '@/rules/maxlength';

export default {

  name: 'AmountInput',

  model: {
    prop: 'value',
    event: 'input',
  },

  props: {
    formIsValid: {
      type: Boolean,
      default: false,
    },
    value: {
      type: null,
      required: true,
    },
    customRules: {
      type: Array,
      default: () => [],
    },
    amountInputLabel: {
      type: String,
      default: 'label.payment_amount',
    },
    isDetailsHidden: {
      type: Boolean,
      default: false,
    },
    // isDisabled is true because of below we use ! operation for change it, it's because we received editable Boolean not disabled or Not
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
    inputMinValue: {
      type: Number,
      default: 0.01,
    },
    inputMaxValue: {
      type: Number,
      default: null,
    },
    commission: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      rules: {
        amount: [ValidationRequired(), ValidationNumber(2), ValidationAmount(), ValidationMaxlength(9), ValidationPattern('^.*[^.]$'), ...this.customRules],
      },
      isChanged: false,
    };
  },
  computed: {
    // isEditableValue() {
    //   if (!this.isEditable || this.isEditable === null || this.isEditable === 'undefined') {
    //     return true;
    //   }
    //   return this.isEditable;
    // },
    hintIsVisible() {
      if (this.isChanged) {
        if ((this.value !== '' && this.value !== ' ')) {
          if (this.inputMinValue && (+this.inputMinValue > +this.value) || this.inputMaxValue && (+this.inputMaxValue < +this.value)) {
            return false;
          }
          return true;
        }
        return false;
      }
      return true;
    },
    commissionValue: {
      get() {
        return this.commission;
      },
      set(value) {
        this.$emit('update:commission', value);
      },
    },
  },
  watch: {
    customRules() {
      this.rules.amount = [...this.rules.amount, ...this.customRules];
    },
  },
  mounted() {
    if (this.inputMinValue) {
      this.rules.amount.push(ValidationMin(this.inputMinValue));
    } else {
      this.rules.amount.push(ValidationMin(0.01));
    }

    if (this.inputMaxValue) {
      this.rules.amount.push(ValidationMax(this.inputMaxValue));
    }
  },
  methods: {
    amountInputHandler(event) {
      this.$emit('input', event);
    },
    handleKeyDown(event) {
      this.isChanged = true;
      const allowedKeyCodes = [46, 8, 37, 39]; // Allow backspace, delete, left arrow, right arrow
      const inputValue = event.target.value;
      const cursorPosition = event.target.selectionStart;
      const charAtCursor = inputValue.charAt(cursorPosition - 1);

      if (
        (event.key === '.' && charAtCursor !== '.' && !inputValue.includes('.')) // Allow the first period character unless already present
        || (event.key >= '0' && event.key <= '9') // Allow digits
        || allowedKeyCodes.includes(event.keyCode)
        || allowedKeyCodes.includes(event.which)
        || (cursorPosition !== 0 && cursorPosition !== inputValue.length)
      ) {
        if (inputValue.length < 9 || allowedKeyCodes.includes(event.keyCode) || allowedKeyCodes.includes(event.which)) return;
      }

      event.preventDefault();
    },
  },

};
</script>

<style lang="scss" scoped>
.default-input-container {
  margin-bottom: 2rem;

  :deep(.v-text-field.v-text-field--enclosed .v-text-field__details) {
    padding: unset;
  }
}

.amount-input-hint{
  margin-top: -20px;

  &-text {
    color: #ACACAC;
    font-family: 'Poppins', 'Montserrat', sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
  }

  &-warning {
    color: #FE8C4C;
  }
}
</style>
